import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "@/lib/api";
import Footer from "@/components/site/Footer";
import Specials from "@/components/site/Specials";
import Menu from "@/components/site/Menu";
import Events from "@/components/site/Events";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Reservations from "@/components/site/Reservations";
import Careers from "@/components/site/Careers";
import PWABadge from "@/components/site/PWABadge";
import { useSettings } from "@/contexts/SettingsContext";
import MaintenancePage from "@/pages/MaintenancePage";

const SECTIONS = {
  "/menu": Menu,
  "/specials": Specials,
  "/events": Events,
  "/gallery": Gallery,
  "/reviews": Reviews,
  "/reservations": Reservations,
  "/careers": Careers,
};

export default function SectionPage() {
  const { pathname } = useLocation();
  const { maintenance_mode } = useSettings();
  const Section = SECTIONS[pathname];
  if (maintenance_mode) return <MaintenancePage />;
  if (!Section) return null;
  return (
    <div data-testid={`section-page-${pathname.slice(1)}`} className="min-h-screen bg-[var(--trio-bg)]">
      <header
        className="sticky top-0 z-40 bg-[var(--trio-bg)]/95 backdrop-blur border-b border-[var(--trio-border)]"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[68px] flex items-center justify-between">
          <Link
            to="/"
            data-testid="section-back-home"
            className="flex items-center gap-2 text-sm sm:text-xs uppercase tracking-widest hover:text-[var(--trio-primary)] py-2 -my-2"
          >
            <ArrowLeft className="w-4 h-4" /> Home
          </Link>
          <Link to="/">
            <img src={ASSETS.logo} alt="Trio" className="h-9 w-auto" />
          </Link>
          <div className="w-16" />
        </div>
      </header>
      <main className="pt-2">
        <Section />
      </main>
      <Footer />
      <PWABadge />
    </div>
  );
}
